import { render, staticRenderFns } from "./match-info.vue?vue&type=template&id=13c6b864&scoped=true"
import script from "./match-info.vue?vue&type=script&lang=js"
export * from "./match-info.vue?vue&type=script&lang=js"
import style0 from "./match-info.vue?vue&type=style&index=0&id=13c6b864&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c6b864",
  null
  
)

export default component.exports